export default "__VITE_ASSET__4louaDu5__ 768w, __VITE_ASSET__P5NIfqjd__ 1280w, __VITE_ASSET__DoWliMiz__ 1920w";